module.exports = __webpack_public_path__ + "img/tffchinaunion.7e12c31a.svg";